<template>
	<div class="page content">
		<van-nav-bar :title="$t('page.profile.navTitle')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
			<van-swipe-item v-for="(v, k) in xuanfeidata.img_url" :key="k">
				<van-image height="260px" width="100%" fit="cover" :src="v">
					<template v-slot:loading>
						<van-loading type="circular" />
					</template>
				</van-image>
			</van-swipe-item>
		</van-swipe>
		<div class="section-title">
			{{ xuanfeidata.username }}
		</div>
		<div class="profile-section">
			<div class="profile-left">
				<h1 class="section-subtitle">
					{{ $t('page.ordlan.ManagerProfile')}}
				</h1>
				<p class="profile-info">
					{{ this.xuanfeidata.xuanfei_name }}
				</p>
				<p class="star-rating">
					{{ $t('page.ordlan.Rating') }}：
					<span class="star" v-for="(v,key) in xuanfeidata.start" ></span>
				</p>
				<p class="profile-info">
					 {{ $t('page.ordlan.ServiceArea') }}：
				</p>
				<p class="profile-info">
					 {{ $t('page.ordlan.TravelAvailable') }}： {{ $t('page.ordlan.Yes') }}
				</p>
			</div>
		</div>
		<div class="box">
			<p class="name">{{ this.xuanfeidata.xuanfei_name }}</p>
			<p class="title">{{ this.xuanfeidata.vo_title }}</p>
			<van-image width="98%" fit="contain" height="100%" v-for="(v, k) in xuanfeidata.img_url" :key="k"
				:src="v" />
			<van-button v-if="false" role="link" @click="openInNewTab(kefuurl)" round  class="button"
				color="linear-gradient(135deg, #3498db, #8e44ad)">{{ $t('page.profile.bookAppointment') }}</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				xuanfeidata: [],
				kefuurl: ''
			};
		},
		methods: {
			back() {

				this.$router.push({
					path: 'Choose'
				});
			},
			getxuanfeidata() {
				this.$http({
					method: 'get',
					url: 'xuanfeidata',
					data: {
						id: this.$route.query.id
					}
				}).then(res => {
					this.xuanfeidata = res.data;
					// console.log('this.xuanfeidata', this.xuanfeidata)
				});
			},
			yuyue() {
				this.$toast(this.$t('page.profile.contactConsultant'));
			},

			openInNewTab(url) {
				window.open(url, '_blank', 'noreferrer');
			}
		},
		created() {
			this.getxuanfeidata();
			this.kefuurl = this.$store.getters.getBaseInfo.kefu !== undefined ? this.$store.getters.getBaseInfo.kefu : this
				.$DEFALUTKF;
		}
	};
</script>

<style>
	.container {
		display: inline-block;
	}

	.box {
		width: 95%;
		margin: 0 auto;
		text-align: center;
		padding-bottom: 6.25rem;
	}

	.name {
		font-size: 1.125rem;
	}

	.title {
		font-size: 0.625rem;
	}

	.button {
		width: 10rem;
		height: 2.5rem;
		font-size: 0.9375rem;
		margin-top: 0.625rem;
	}

	.section-title {
		margin-top: -8px;
		font-size: 20px;
		padding: 3.2vw 0;
		color: #fff;
		text-align: center;
		background: linear-gradient(135deg, #3498db, #8e44ad);
	}
	
	.content .profile-section{
	    animation: fadeInUp .4s ease forwards;
	    display: flex;
	    text-align: left;
	    width: 100%;
	    margin: 0 auto;
	    padding: 1.41333vw 3%;
	    position: relative;
	    background: #fff;
	    border-bottom: 1px solid #f0f0f0
	}
	
	.content .profile-section .profile-left{
	    max-width: 100%;
	    flex: 1
	}
	
	.content .profile-section .profile-left .section-subtitle{
	    text-align: left
	}
	
	.content .profile-section .profile-info{
	    font-size: 3.54667vw;
	    color: #666;
	    margin: 2.13333vw 0
	}
	
	.content .profile-section .star-rating{
	    display: flex;
	    justify-content: flex-start;
	    align-items: center;
	    font-size: 3.54667vw;
	    color: #666
	}
	
	.content .profile-section .star-rating .star{
	    width: 4.26667vw;
	    height: 4.26667vw;
	    background: url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='%230f3460'%3e%3cpath%20d='M12%2017.27L18.18%2021l-1.64-7.03L22%209.24l-7.19-.61L12%202%209.19%208.63%202%209.24l5.46%204.73L5.82%2021z'/%3e%3c/svg%3e") no-repeat;
	    margin-left: .85333vw
	}
	
	.content .profile-section .action-button{
	    position: absolute;
	    right: 7.09333vw;
	    bottom: 2.82667vw;
	    color: #fff;
	    padding: 1.41333vw 4.26667vw;
	    background: linear-gradient(135deg,#ff9f43,#ff6b6b);
	    border-radius: 1.41333vw;
	    text-decoration: none;
	    font-size: 3.84vw;
	    transition: all .3s ease;
	    cursor: pointer
	}
	
	
	
	
</style>